import React, { ForwardedRef } from 'react';
import { useTranslation } from 'react-i18next';
import InvalidFeedback from './invalid-feedback.component';

interface AdvanceCheckboxProps {
  options: {
    value: string;
    title: string;
    description?: string;
    icon: React.ReactNode;
    bgClass?: string;
    badge?: string;
    type?: string;
  }[];
  errors?: any;
  value: string[];
  label?: string;
  required?: boolean;
  optional?: boolean;
  onChange: (value: string[]) => void;
}

const AdvanceCheckbox = React.forwardRef<HTMLInputElement, AdvanceCheckboxProps>(
  (
    {
      label,
      options,
      errors,
      value = [],
      required = false,
      optional = false,
      onChange
    }: AdvanceCheckboxProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const { t } = useTranslation();

    const handleToggle = (val: string) => {
      const isChecked = value.includes(val);

      const audio = new Audio(
        `/assets/media/audio/${isChecked ? 'offSelected' : 'onSelected'}.mp3`
      );
      audio.play();

      if (isChecked) {
        onChange(value.filter((v) => v !== val));
      } else {
        onChange([...value, val]);
      }
    };

    return (
      <div className="mb-7">
        {label && (
          <label className={`form-label mb-4 ${required ? 'required' : ''}`}>
            {label}
            {optional && <span className="fs-8 text-muted ms-1">({t('general.optional')})</span>}
          </label>
        )}
        <div className="d-flex flex-wrap gap-4 mb-6">
          {options.map((option, index) => {
            const isSelected = value.includes(option.value);
            const id = `adv-checkbox-${option.value}`;
            const cardTypeClass = option.type ?? 'primary';

            return (
              <div key={option.value} className={`animate-fadeInUp animate-delay-${index}`}>
                <div className={`cardC-checkbox card-hover-n `}>
                  <input
                    type="checkbox"
                    id={id}
                    value={option.value}
                    checked={isSelected}
                    onChange={() => handleToggle(option.value)}
                    ref={ref}
                  />
                  <label
                    htmlFor={id}
                    className={`cardC animate-fadeInUp animate-delay-${index} ${cardTypeClass}`}
                  >
                    <span className="check-icon">✔</span>
                    <div className="p-4 d-flex justify-content-center">
                      <img
                        src={`/assets/media/logos/${option.value}-logo.png`}
                        alt=""
                        width={'45%'}
                      />
                    </div>
                    <div className="cardC-content py-3 px-2">
                      <h2 className="fw-bold mb-1 text-center">{option.title}</h2>
                      {option.description && <p className="mb-0">{option.description}</p>}
                      {option.badge && <span className="badge mt-2 d-block">{option.badge}</span>}
                    </div>
                  </label>
                </div>
              </div>
            );
          })}
        </div>
        <span className="text-danger mb-3 d-block">{errors?.message}</span>
        <InvalidFeedback error={errors} />
      </div>
    );
  }
);

export default AdvanceCheckbox;
